/**
 * Owner: Masa Bayu
 * File: adam-feature-entitlement-sot.ts
 * Date:Time: 2026-09-23 09:24
 * Description: AE-01 — single server-side ADAM Feature Subscription SoT authority.
 */
/** Official locked SoT identity — not Content Entitlement / PE1 / Platform Access. */
export const ADAM_FEATURE_ENTITLEMENT_SOT = Object.freeze({
    id: 'adam-feature-subscription-entitlement',
    status: 'OWNER_LOCKED',
    plane: 'entitlement',
    authority: 'server-side',
    ownerAccept: '2026-09-23 09:22',
    buildAuth: 'BUILD-AUTH-AE-01-10',
    notAuthority: Object.freeze([
        'client',
        'ui',
        'dom',
        'content-entitlement-pe1',
        'platform-access',
        'author-authorization',
    ]),
});
export const ADAM_FEATURE_VS_CONTENT_ENTITLEMENT = Object.freeze({
    adamFeatureSubscription: 'adam-feature-subscription-entitlement',
    contentEntitlementPe1: 'contentId-commerce-pe1',
    equal: false,
    mergeForbidden: true,
});
//# sourceMappingURL=adam-feature-entitlement-sot.js.map